import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { HiroEntryService, HiroEntryServiceImpl } from './service/hiro-entry.service';
import { HIRO_EVENT_PROXY, HiroEventProxy } from '@patsnap/hiro-event-proxy';

export const hiroEntryModule = (bind: interfaces.Bind) => {
    bind(HIRO_EVENT_PROXY).toConstantValue(new HiroEventProxy());
    bind(HiroEntryService).to(HiroEntryServiceImpl);
};
